// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}

/** When having the small dialog style we override the modal styling so dialogs look more dialog like */
@media only screen and (max-width: 512px) {
.dialog__modal .modal-wrapper--small .modal-container {
    width: fit-content;
    height: unset;
    max-height: 90%;
    position: relative;
    top: unset;
    border-radius: var(--border-radius-large);
}
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-49ff4e77] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.dialog[data-v-49ff4e77] {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
}
.dialog__modal[data-v-49ff4e77] .modal-wrapper .modal-container {
  display: flex !important;
  padding-block: 4px 0;
  padding-inline: 12px 0;
}
.dialog__modal[data-v-49ff4e77] .modal-wrapper .modal-container__content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.dialog__wrapper[data-v-49ff4e77] {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.dialog__wrapper--collapsed[data-v-49ff4e77] {
  flex-direction: column;
}
.dialog__navigation[data-v-49ff4e77] {
  display: flex;
  flex-shrink: 0;
}
.dialog__wrapper:not(.dialog__wrapper--collapsed) .dialog__navigation[data-v-49ff4e77] {
  flex-direction: column;
  overflow: hidden auto;
  height: 100%;
  min-width: 200px;
  margin-inline-end: 20px;
}
.dialog__wrapper.dialog__wrapper--collapsed .dialog__navigation[data-v-49ff4e77] {
  flex-direction: row;
  justify-content: space-between;
  overflow: auto hidden;
  width: 100%;
  min-width: 100%;
}
.dialog__name[data-v-49ff4e77] {
  font-size: 21px;
  text-align: center;
  height: fit-content;
  min-height: var(--default-clickable-area);
  line-height: var(--default-clickable-area);
  overflow-wrap: break-word;
  margin-block: 0 12px;
}
.dialog__content[data-v-49ff4e77] {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding-inline-end: 12px;
}
.dialog__text[data-v-49ff4e77] {
  padding-block-end: 6px;
}
.dialog__actions[data-v-49ff4e77] {
  box-sizing: border-box;
  display: flex;
  gap: 6px;
  align-content: center;
  justify-content: end;
  width: 100%;
  max-width: 100%;
  padding-inline: 0 12px;
  margin-inline: 0;
  margin-block: 0;
}
.dialog__actions[data-v-49ff4e77]:not(:empty) {
  margin-block: 6px 12px;
}
@media only screen and (max-width: 512px) {
.dialog__name[data-v-49ff4e77] {
    text-align: start;
    margin-inline-end: var(--default-clickable-area);
}
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcDialog-X7BRqUGJ.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,uGAAuG;AACvG;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,yCAAyC;AAC7C;AACA,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;EAC1C,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,aAAa;EACb,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;AACA;IACI,iBAAiB;IACjB,gDAAgD;AACpD;AACA","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n\n/** When having the small dialog style we override the modal styling so dialogs look more dialog like */\n@media only screen and (max-width: 512px) {\n.dialog__modal .modal-wrapper--small .modal-container {\n    width: fit-content;\n    height: unset;\n    max-height: 90%;\n    position: relative;\n    top: unset;\n    border-radius: var(--border-radius-large);\n}\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-49ff4e77] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.dialog[data-v-49ff4e77] {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n}\n.dialog__modal[data-v-49ff4e77] .modal-wrapper .modal-container {\n  display: flex !important;\n  padding-block: 4px 0;\n  padding-inline: 12px 0;\n}\n.dialog__modal[data-v-49ff4e77] .modal-wrapper .modal-container__content {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.dialog__wrapper[data-v-49ff4e77] {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n.dialog__wrapper--collapsed[data-v-49ff4e77] {\n  flex-direction: column;\n}\n.dialog__navigation[data-v-49ff4e77] {\n  display: flex;\n  flex-shrink: 0;\n}\n.dialog__wrapper:not(.dialog__wrapper--collapsed) .dialog__navigation[data-v-49ff4e77] {\n  flex-direction: column;\n  overflow: hidden auto;\n  height: 100%;\n  min-width: 200px;\n  margin-inline-end: 20px;\n}\n.dialog__wrapper.dialog__wrapper--collapsed .dialog__navigation[data-v-49ff4e77] {\n  flex-direction: row;\n  justify-content: space-between;\n  overflow: auto hidden;\n  width: 100%;\n  min-width: 100%;\n}\n.dialog__name[data-v-49ff4e77] {\n  font-size: 21px;\n  text-align: center;\n  height: fit-content;\n  min-height: var(--default-clickable-area);\n  line-height: var(--default-clickable-area);\n  overflow-wrap: break-word;\n  margin-block: 0 12px;\n}\n.dialog__content[data-v-49ff4e77] {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  padding-inline-end: 12px;\n}\n.dialog__text[data-v-49ff4e77] {\n  padding-block-end: 6px;\n}\n.dialog__actions[data-v-49ff4e77] {\n  box-sizing: border-box;\n  display: flex;\n  gap: 6px;\n  align-content: center;\n  justify-content: end;\n  width: 100%;\n  max-width: 100%;\n  padding-inline: 0 12px;\n  margin-inline: 0;\n  margin-block: 0;\n}\n.dialog__actions[data-v-49ff4e77]:not(:empty) {\n  margin-block: 6px 12px;\n}\n@media only screen and (max-width: 512px) {\n.dialog__name[data-v-49ff4e77] {\n    text-align: start;\n    margin-inline-end: var(--default-clickable-area);\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
